import cogoToast from "cogo-toast";

const errorHandler = (error, position, auth = false) => {
    const option = {
        position: position,
        hideAfter: 5
    };

    if(error.response) {
        switch (error.response.status) {
            case 401:
                if(auth) {
                    cogoToast.error("Email or password is incorrect!", option);
                } else {
                    localStorage.removeItem("jwtToken");
                    localStorage.removeItem("redux_localstorage_simple");
                    window.location.href = "/";
                }
                break;

            case 422:
                cogoToast.error( error.response.data['error'].details !== undefined ? error.response.data['error'].details[0].message : error.response.data['error'], option);
                break;

            default:
                cogoToast.error("Error 446: Something went wrong!.", option);
        }
    } else {
        cogoToast.error("Error 500: Server connection failed!.", option);
    }
};

export default errorHandler;
